// extracted by mini-css-extract-plugin
export default {"grid":"channelList_grid__JZBp-","row":"channelList_row__5mE5a","label":"channelList_label__fY542","sentinel":"channelList_sentinel__TUZiT"};